/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Studyprograms_Study_Geography15Inputs */

const en__field__enum_studyprograms_study_geography15 = /** @type {(inputs: _Field__Enum_Studyprograms_Study_Geography15Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geography`)
};

const de__field__enum_studyprograms_study_geography15 = /** @type {(inputs: _Field__Enum_Studyprograms_Study_Geography15Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geographie`)
};

/**
* | output |
* | --- |
* | "Geography" |
*
* @param {_Field__Enum_Studyprograms_Study_Geography15Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_studyprograms_study_geography15 = /** @type {((inputs?: _Field__Enum_Studyprograms_Study_Geography15Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Studyprograms_Study_Geography15Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__enum_studyprograms_study_geography15(inputs)
	return de__field__enum_studyprograms_study_geography15(inputs)
});
export { _field__enum_studyprograms_study_geography15 as "_field__enum_studyPrograms_STUDY_GEOGRAPHY" }